export const ensureCallForJoin = (callsStore, callSid, fallbackCall) => {
  if (fallbackCall?.callSid === callSid) callsStore.addCall(fallbackCall);

  return (
    callsStore.calls.find(call => call.callSid === callSid) ||
    (fallbackCall?.callSid === callSid ? fallbackCall : null)
  );
};
